import { Link } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { money } from "../config/brand";

export const ProductCard = ({ product }) => {
  const { add } = useCart();
  const soldOut = product.sold_out;
  const comingSoon = product.coming_soon;
  const [first, second] = product.images || [];

  return (
    <div className="group relative p-1.5 -m-1.5 outline outline-1 outline-transparent hover:outline-black transition-[outline-color]" data-testid={`product-card-${product.slug}`}>
      <div className="relative overflow-hidden bg-white aspect-[1/1]">
        <Link
          to={`/products/${product.slug}`}
          data-testid={`product-link-${product.slug}`}
          aria-label={product.name}
          className="block w-full h-full"
        >
          {first && (
            <img
              src={first}
              alt={product.name}
              loading="lazy"
              className="w-full h-full object-contain transition-transform duration-700 ease-out group-hover:scale-[1.03]"
            />
          )}
          {second && (
            <img
              src={second}
              alt=""
              loading="lazy"
              aria-hidden="true"
              className="absolute inset-0 w-full h-full object-contain bg-white opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"
            />
          )}
        </Link>
        {!soldOut && !comingSoon && product.sizes?.length > 0 && (
          <div
            className="absolute bottom-0 inset-x-0 hidden md:flex justify-center gap-1 py-2.5 bg-white/95 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out"
            data-testid={`quick-add-${product.slug}`}
          >
            <span className="text-[9px] tracking-[0.2em] text-black/40 self-center mr-2">
              QUICK ADD
            </span>
            {product.sizes.map((s) => (
              <button
                key={s.label}
                data-testid={`quick-add-${product.slug}-${s.label}`}
                disabled={s.inventory === 0}
                onClick={() =>
                  add({
                    slug: product.slug,
                    name: product.name,
                    price: product.price,
                    image: first,
                    size: s.label,
                    qty: 1,
                  })
                }
                className="px-2 text-[11px] font-medium hover:bg-black hover:text-white transition-colors disabled:line-through disabled:text-black/25 disabled:hover:bg-transparent disabled:hover:text-black/25"
              >
                {s.label}
              </button>
            ))}
          </div>
        )}
      </div>
      {/* Paly-style caption: one row, name left (single line, ellipsis) / price right. */}
      <div className="mt-3 flex items-baseline justify-between gap-3 min-w-0">
        <Link
          to={`/products/${product.slug}`}
          className="block min-w-0 text-[11px] font-medium tracking-[0.02em] uppercase leading-[1.3] truncate hover:opacity-50 transition-opacity"
          title={product.name}
        >
          {product.name}
        </Link>
        {soldOut ? (
          <span
            className="text-[11px] font-medium tracking-[0.04em] text-[#e50000] flex-shrink-0"
            data-testid={`sold-out-${product.slug}`}
          >
            SOLD OUT
          </span>
        ) : (
          <span className="text-[10px] md:text-[11px] tracking-[0.02em] text-black/80 whitespace-nowrap flex-shrink-0">
            {money(product.price)}
          </span>
        )}
      </div>
    </div>
  );
};
